import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { typography } from './typography';
import { checkbox } from './components/checkbox';
import { textField } from './components/textField';
import { button } from './components/button';
import { modal } from './components/modal';
import { autocomplete } from './components/autocomplate';

export const theme = createTheme({
  palette,
  typography,
  spacing: 8,
  shape: {
    borderRadius: 10,
  },
});

theme.components = {
  ...checkbox(theme),
  ...textField(theme),
  ...modal(theme),
  ...autocomplete(theme),
  MuiButton: button(theme),
  MuiTypography: {
    defaultProps: {
      color: 'text.primary',
    },
  },
};
